import { Injectable } from '@angular/core';

@Injectable()
export class AudioProvider {

  audioPlayer: HTMLAudioElement
  audioUrl: string
  isWaiting: boolean = false

  constructor() {}

  play(audioUrl: string) {
    if (this.audioUrl === audioUrl) {
      if (this.isPlaying) {
        this.pause()
      } else {
        this.audioPlayer.play()
      }
    } else {
      this.stop()
      this.audioUrl = audioUrl
      this.audioPlayer = new Audio(audioUrl)
      this.isWaiting = true

      // NOTE: when Chrome debugger set to "low-end mobile" it can take, say, 3000 milliseconds to
      // canplay and, say, 5000 milliseconds to canplaythrough.
      
      // const start = performance.now()
      this.audioPlayer.oncanplay = () => {
        // console.log('can play ' + (performance.now() - start))
        // this.isWaiting = false
        // this.audioPlayer.play()
      }

      this.audioPlayer.oncanplaythrough = () => {
        // console.log('can play through ' + (performance.now() - start))
        this.isWaiting = false
        this.audioPlayer.play()
      }
    }
  }

  pause() {
    if (this.isWaiting || this.isPlaying) {
      this.isWaiting = false
      this.audioPlayer.pause()
    }
  }

  stop() {
    this.pause()
    this.audioPlayer = null
    this.audioUrl = null
    this.isWaiting = false
  }

  get isPlaying(): boolean {
    return this.audioPlayer && (!this.isWaiting && !this.audioPlayer.paused && !this.audioPlayer.ended)
  }

}
